import { render, staticRenderFns } from "./tradespeople.vue?vue&type=template&id=3db2aa80&scoped=true"
import script from "./tradespeople.vue?vue&type=script&lang=js"
export * from "./tradespeople.vue?vue&type=script&lang=js"
import style0 from "./tradespeople.vue?vue&type=style&index=0&id=3db2aa80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db2aa80",
  null
  
)

export default component.exports